import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { useField } from 'formik';

import FormInput from '../form-input/FormInput';
import UrlMenu from './UrlMenu';

type Props = Omit<React.ComponentProps<typeof FormInput>, 'type'> & {
  type?: 'url';
};

const FormUrlInput = ({
  name,
  ...props
}: Props) => {
  const [field, meta] = useField({ name });

  return (
    <FormInput
      name={name}
      {...props}
      type="text"
      endAdornment={(
        <InputAdornment position="end">
          <UrlMenu url={field.value} disabled={Boolean(meta.error)} />
        </InputAdornment>
      )}
    />
  );
};

export default FormUrlInput;
